import type { GameRowValue } from '../../../backend.d.ts'
import type { LobbyRowValue } from '../../../backend.d.ts'
import type { MapRowValue } from '../../../backend.d.ts'
import { modifyMutable, produce, unwrap } from 'solid-js/store'
import type { Nullable } from '../../../typescript'
import { deepClone } from "../../deep_clone"
import { useActionLogsSignal } from '../../../rx/signal/useActionLogsSignal'
import { useEnginePrevStateSignal } from '../../../rx/signal/useEnginePrevStateSignal'
import type { Engine } from './Engine.type'
import { setEngineStateFromExternal } from './setEngineState'

type SyncableRow = (GameRowValue | MapRowValue | LobbyRowValue) & {
  file_id?: string
}

export default function syncEngineWithPropsRow(engine: Engine, row: Nullable<SyncableRow>) {
  if (row) {
    const { data, action_logs, file_id, ...workspaceRow } = row
    const newState = unwrap(data)
    const setActionLogs = useActionLogsSignal(engine)[1]
    const [, setPrevState] = useEnginePrevStateSignal(engine)
    const clonedState = deepClone(newState)
    const clonedPrevState = deepClone(newState)
    engine.workspaceMapEntry = file_id ? { file_id, row: deepClone(workspaceRow) } : null
    modifyMutable(engine, produce(() => {
      setEngineStateFromExternal(engine, clonedState)
    }))
    setPrevState(clonedPrevState)
    setActionLogs(deepClone(unwrap(action_logs)) || [])
  }
}
